// Dev-only, PII-safe logger. Never logs tokens, passwords or personal data.
export const logError = (context, err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[${context}] ${err?.name || "Error"}: ${err?.message || "unknown"}`);
  }
};
